import React, { MouseEvent } from 'react';

import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';
import AL from './assets/states/Al';
import AK from './assets/states/Ak';
import AZ from './assets/states/Az';
import AR from './assets/states/Ar';
import CA from './assets/states/Ca';
import CO from './assets/states/Co';
import CT from './assets/states/Ct';
import DE from './assets/states/De';
import FL from './assets/states/Fl';
import GA from './assets/states/Ga';
import HI from './assets/states/Hi';
import ID from './assets/states/Id';
import IL from './assets/states/Il';
import IN from './assets/states/In';
import IA from './assets/states/Ia';
import KS from './assets/states/Ks';
import KY from './assets/states/Ky';
import LA from './assets/states/La';
import ME from './assets/states/Me';
import MD from './assets/states/Md';
import MA from './assets/states/Ma';
import MI from './assets/states/Mi';
import MN from './assets/states/Mn';
import MS from './assets/states/Ms';
import MO from './assets/states/Mo';
import MT from './assets/states/Mt';
import NE from './assets/states/Ne';
import NV from './assets/states/Nv';
import NH from './assets/states/Nh';
import NJ from './assets/states/Nj';
import NM from './assets/states/Nm';
import NY from './assets/states/Ny';
import NC from './assets/states/Nc';
import ND from './assets/states/Nd';
import OH from './assets/states/Oh';
import OK from './assets/states/Ok';
import OR from './assets/states/Or';
import PA from './assets/states/Pa';
import RI from './assets/states/Ri';
import SC from './assets/states/Sc';
import SD from './assets/states/Sd';
import TN from './assets/states/Tn';
import TX from './assets/states/Tx';
import UT from './assets/states/Ut';
import VT from './assets/states/Vt';
import VA from './assets/states/Va';
import WA from './assets/states/Wa';
import WV from './assets/states/Wv';
import WI from './assets/states/Wi';
import WY from './assets/states/Wy';
import DC from './assets/states/Dc';
import PR from './assets/states/Pr';

interface StateLinkProps {
  state: string;
  onClick: (state: string) => void;
}

const stateComponents = {
  AL,
  AK,
  AZ,
  AR,
  CA,
  CO,
  CT,
  DE,
  FL,
  GA,
  HI,
  ID,
  IL,
  IN,
  IA,
  KS,
  KY,
  LA,
  ME,
  MD,
  MA,
  MI,
  MN,
  MS,
  MO,
  MT,
  NE,
  NV,
  NH,
  NJ,
  NM,
  NY,
  NC,
  ND,
  OH,
  OK,
  OR,
  PA,
  RI,
  SC,
  SD,
  TN,
  TX,
  UT,
  VT,
  VA,
  WA,
  WV,
  WI,
  WY,
  DC,
  PR,
};

const StateLink: React.FC<StateLinkProps> = ({ state, onClick }) => {
  const SVG = stateComponents[state];

  const onClickHandler = (e: MouseEvent) => {
    e.preventDefault();

    onClick(state);
  };

  if (!SVG) {
    return null;
  }

  return (
    <a
      href={`?state=${state}`}
      className="btn btn-sm rounded-pill text-center d-flex my-3 px-3 align-items-center"
      style={{
        gap: '0.5rem',
        backgroundColor: getComputedCSSVariable('blue-200'),
        borderColor: getComputedCSSVariable('blue-200'),
        fontSize: '1rem',
        margin: '0 0.125rem',
      }}
      onClick={onClickHandler}
    >
      <SVG style={{
        height: '1.5rem',
        width: '1.5rem',
      }}
      />
      {state}
    </a>
  );
};

export default StateLink;
